import React, { useState } from "react";
import PropTypes from "prop-types";
import Heading from "atoms/Heading";
import Text from "atoms/Text";
import InputField from "atoms/InputField";
import Button from "atoms/Button";
import Dropdown from "../molecules/Dropdown";
import { getCountryCallingCode } from "react-phone-number-input/input";
import Card from "atoms/Card";

const LoginForm = ({
  handleSubmit,
  control,
  error,
  register,
  loginDetails,
  handleCountryChange,
  countryOptionsList,
  onSubmit,
  country,
  setError,
  onClickBackArrow,
  setValue,
  getValues,
}) => {
  const checkDisabled = () => {
    if (loginDetails.loginType === "") return true;
    if (
      loginDetails.loginType === "mobileNumber" &&
      loginDetails.mobileNumber?.length !== 10
    )
      return false;
    if (
      loginDetails.loginType === "email" &&
      loginDetails.emailId?.length === 0
    )
      return false;
  };

  const [loginType, setLoginType] = useState(getValues("loginType"));
  const [disabled, setDisabled] = useState(checkDisabled());

  const handleMobileNumberChange = (event) => {
    const val = event.target.value.toString();
    if (val.length != 0) {
      setValue("mobileNumber", val, { shouldValidate: true });
      setDisabled(false);
      return;
    }
    setDisabled(true);
    setError([]);
  };

  const handleEmailChange = (event) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const val = event.target.value.toString();
    if (emailPattern.test(val)) {
      setValue("emailId", val, { shouldValidate: true });
      setDisabled(false);
      return;
    }
    setDisabled(true);
    setError([]);
  };

  return (
    <Card
      cardClass="p-6 shadow-lg absolute top-[150px] left-1/2 transform -translate-x-1/2 translate-x-[98px] opacity-100 rounded-[39.29px] flex flex-col items-center"
      cardBg="bg-oneConnectBg"
      cardWidth="w-[360px]"
      cardHeight="min-h-[390px] h-auto"
    >
      <Heading
        type="h2"
        className="text-brandGreen flex items-center justify-center gap-2"
      >
        <img
          src="/images/1CLogo.svg"
          alt="1C Logo"
          className="h-14 w-auto mix-blend-multiply"
        />
        <span className="font-black">1 Connect</span>
      </Heading>

      <Text className="font-schibsted text-[16px] leading-[100%] tracking-wide align-middle text-oneConnectBlue text-center mt-8">
        {loginType === "mobileNumber"
          ? "Login with your Mobile and OTP"
          : "Login with your Email and OTP"}
      </Text>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-6 w-full flex flex-col items-center"
      >
        {loginType === "mobileNumber" ? (
          <>
            <div className="mt-2 w-full flex justify-center">
              <div className="w-[242px]">
                <span className="block mb-3 text-md text-gray-900">
                  Mobile Number
                </span>

                <div className="grid grid-cols-[5.5rem,1fr] gap-2">
                  <Dropdown
                    name="countryCode"
                    id="countryCode"
                    value={country}
                    onChange={handleCountryChange}
                    defaultValue={+getCountryCallingCode("IN")}
                    options={countryOptionsList}
                    isSearchable={true}
                    className={`select-dropdown rounded-none ${
                      error.length != 0
                        ? " border border-error border-b-error"
                        : ""
                    }`}
                    control={control}
                    mainClass="mb-0"
                  />
                  <InputField
                    id="mobileNumber"
                    name="mobileNumber"
                    type="number"
                    className="rounded-none h-10"
                    placeholder="Mobile Number"
                    maxLength={10}
                    register={register}
                    isRequired={true}
                    change={handleMobileNumberChange}
                    variant={error.length != 0 ? "error" : "outlineBottom"}
                    bottomMargin="mb-0"
                  />
                </div>
              </div>
            </div>

            {error.length != 0 && (
              <div className="text-sm text-error mt-1 text-center px-8">
                {error.length != 0 && error}
              </div>
            )}
            <Button
              type="submit"
              variant="brandGreenBtn"
              fontWeight="font-bold"
              btnClass="w-[242px] h-12 mt-4"
              disabled={disabled}
            >
              Get OTP
            </Button>
          </>
        ) : (
          <>
            <div className="mt-2 w-full flex justify-center">
              <div className="w-[242px]">
                <span className="block mb-3 text-md text-gray-900">Email</span>
                <InputField
                  id="emailId"
                  name="emailId"
                  type="email"
                  className="rounded-none h-10"
                  placeholder="Enter your Email"
                  register={register}
                  isRequired={true}
                  change={handleEmailChange}
                  variant={error.length != 0 ? "error" : "outlineBottom"}
                  bottomMargin="mb-0"
                />
              </div>
            </div>
            {error.length != 0 && (
              <div className="text-sm text-error mt-1 text-center px-4">
                {error.length != 0 && error}
              </div>
            )}
            <Button
              type="submit"
              variant="brandGreenBtn"
              fontWeight="font-bold"
              btnClass="w-[242px] h-12 mt-4"
              disabled={disabled}
            >
              Get OTP
            </Button>
          </>
        )}

        <Button
          onClick={() => {
            setLoginType((prev) => {
              setError([]);
              setDisabled(
                getValues(
                  prev === "mobileNumber" ? "emailId" : "mobileNumber"
                ) === null ||
                  getValues(
                    prev === "mobileNumber" ? "emailId" : "mobileNumber"
                  ) === undefined ||
                  getValues(
                    prev === "mobileNumber" ? "emailId" : "mobileNumber"
                  ) === ""
              );
              setValue(
                "loginType",
                prev === "mobileNumber" ? "email" : "mobileNumber"
              );
              return prev === "mobileNumber" ? "email" : "mobileNumber";
            });
          }}
          type="button"
          variant="loginButton"
          fontWeight="font-normal"
          btnClass="w-full mt-5 font-schibsted text-[14px] leading-[100%] tracking-wider align-middle underline text-oneConnectBlue"
        >
          Login with {loginType === "mobileNumber" ? "Email" : "Mobile Number"}
        </Button>
      </form>
    </Card>
  );
};

export default LoginForm;

LoginForm.propTypes = {
  loginDetails: PropTypes.object,
  error: PropTypes.string,
};
